export class UserLoggedIn {
    constructor(payload) {
        this.payload = payload;
    }
}
UserLoggedIn.type = '[Auth] Logged In';
export class UserAllowedClaimsPreAuth {
}
UserAllowedClaimsPreAuth.type = '[AUTH] User Allowed Claims Pre-Auth';
export class FetchFeatureFlags {
}
FetchFeatureFlags.type = '[AUTH] Fetch Feature Flags';
//# sourceMappingURL=auth.actions.js.map